module.exports = __webpack_public_path__ + "static/banner-texture-new-155e5119607061869ae62d9d40eb62c0.png";